/*
*  This is a simple modal for displaying content (markup or jquery) with hooks (OK, cancel).
*  ... currently extend to create a modal view (see 'modalLoading') ... now more examples ...
* TODO:
*   - draggable ( though that may break other things that are content dependent inside -- eg chosen dropdowns )
*   - accessibility: disable tab-able content outside the modal; when available 'new' dialog element or maybe a polyfill
*   - with implementation of subviews (DVBC-1586) refactor dialogs extending this prototype
*   - would also want to change markup to be a form and use onSubmit
* */

require('./index.less');

var Marionette = require('marionette'),
    Backbone = require('backbone'),
    ResizeSensor = require('../../../shim/ResizeSensorShim');


require('backbone.mousetrap');
require('jqIframeShim');
require('jqOverlay');


var confirmTypes = {
    warning: {
        icon: 'icon-attention-circled',
        color: '#9D261D'
    },
    info: {
        icon: 'icon-info-circled',
        color: '#9D261D'
    }
};

var defaults = {
    actionBtn: 'OK',
    cancelBtn: 'Cancel',
    hideFooter: false,  // need to override this one,
    showCancelBtn: false, //need to override this one,
    showDismissBtn: true,
    overlay: true,

    confirmIcon: '',
    confirmColor: '',

    content: '', // html or jquery obj -- and now BackboneView
    contentIsJquery: false,
    contentIsBackboneView: false,

    $container: null, // required if creating overlay
    title: null, // The header of the title -- if provided, header is shown

    width: null, // Set a custom width ( pixels ),
    height: null, // Set a custom height ( pixels )
    omitBodyPadding: false,
    omitBodyOverflow: false,


    onClose: null,
    okCB: null

    /* derived */


};


// Note: content can be jquery object or text -- sometimes template passed in -- use partial?

module.exports = Marionette.LayoutView.extend({

    template: require('./modal.hbs'),
    className: "FV-modal",

    //TODO: what required & err if not provided: ($container: if overlay)
    initialize: function(options) {

        var o = options,
            confType = o.confirmType,

            content = o.content,

            s = this.settings = _.extend( {}, defaults, o, { /* don't override proto! */

                confirmIcon: confType ? confirmTypes[confType].icon : '',
                confirmColor: confType ? confirmTypes[confType].color : '',

                contentIsJquery: content && content.jquery,
                contentIsBackboneView: content && content instanceof Backbone.View

            });

        this.resizeSensor = null;  // (set onShow)

        /* Plugin Relies on Container Having Position */
        var $cont = s.$container;
        $cont && $cont.css('position') === 'static' &&
            $cont.css('position', 'relative').data('positionApplied', true);

        return this;

    },


    serializeData: function() {

        var s = this.settings;

        return {

            showHeader:  s.title && s.title.length > 0,
            showDismissBtn: s.showDismissBtn,
            title:  s.title, //will be shown if header is shown
            confirmIcon: s.confirmIcon,
            showConfirmIcon: s.confirmIcon && s.confirmIcon.length > 0,
            confirmColor: s.confirmColor && s.confirmColor,

            rawHTMLContent: !s.contentIsJquery && !s.contentIsBackboneView // could check if string
                ? s.content
                : '',

            contentIsBackboneView: s.contentIsBackboneView,

            //i think when pass in subtemplate
            showFooter:  !(s.hideFooter),
            showCancelBtn:  s.showCancelBtn,

            cancelBtn: s.cancelBtn,
            actionBtn: s.actionBtn,

            customWidth: s.width !== null,
            width: s.width,

            customHeight: s.height !== null,
            height: s.height,

            leftMargin: s.width ? ( parseFloat(s.width) / 2 * -1 ) + 'px' : '-200px', //latter is the default css
            omitBodyPadding: s.omitBodyPadding,

            omitBodyOverflow: s.omitBodyOverflow //eg if want to use own scrolling (w/top nav bar)


        };

    },

    onRender: function() {

        this.unwrap(); // (unwrap called in proto)

        if ( this.settings.contentIsJquery ) {
            this.ui.content.append( this.settings.content );
        }

    },

    onBeforeShow: function() {

        if ( this.settings.contentIsBackboneView ) {
            this.contentRegion.show( this.settings.content );
        }
    },

    onShow: function() {

        this.settings.overlay && this.settings.$container.overlay();

        this.$el.iframeShim();

        this.$el.focus();

        /*
        * DVBC-1599: change the size of the shim when the size of the modal changes.
        * Later may want to incorporate the code directly into the shim plugin, but for
        * now this modal dialog is the only use case.
        * Potentially make optional -- only apply the sensor for dialog's we know who's size dynamic.
        * Also -- across - the board -- may only want to apply the shim conditionally (eg if using IE).
        * */


        this.resizeSensor = new ResizeSensor( this.el, _.bind( function() {
            this.$el.iframeShim('sizeAndPosition');
        }, this));


    },
    ui: {
        content:        '.FV-modal-content',
        okBtn:          '#okBtn',
        cancelBtn:      '#cancelBtn',
        closeBtn:       '.close'
    },
    regions: {
        contentRegion:  '.FV-modal-region'
    },
    events: {
        'click @ui.okBtn'      : 'ok',
        'click @ui.cancelBtn'  : 'destroy',
        'click @ui.closeBtn'   : 'destroy'
    },
    keyboardEvents: {
        'enter' : 'ok',
        'esc'   : 'destroy'
    },
    ok: function() {
        this.destroy();
        this.settings.okCB && this.settings.okCB();
    },
    unfocusBtn: function() {

        this.ui.okBtn.toggleClass('btn-focus-primary'); //TODO: fix this : have it focus in the box (..still?)
        this.ui.cancelBtn.toggleClass('btn-focus');

    },
    destroy: function() {

        this.resizeSensor && this.resizeSensor.detach();

        /* DVBC-1151 -- must remove the iframe shim prior to remove el from the DOM */
        this.$el.iframeShim('destroy');

        Marionette.LayoutView.prototype.destroy.apply( this, arguments ); // ( Will destroy region if exists )

        var s = this.settings;
        if (s.$container) {
            s.$container.data('positionApplied') && s.$container.css('position', '');
            s.$container.trigger('overlay:close');
        }

        this.$('*').remove();

        s.onClose && s.onClose();
        
        this.remove();
        this.$el = null;
        this.el = null;
    }


});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/common/modal/modal.js
 ** module id = 110
 ** module chunks = 0
 **/